import { render, staticRenderFns } from "./CriarFaixa.vue?vue&type=template&id=156f2776"
import script from "./CriarFaixa.vue?vue&type=script&lang=js"
export * from "./CriarFaixa.vue?vue&type=script&lang=js"
import style0 from "./CriarFaixa.vue?vue&type=style&index=0&id=156f2776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports